import { Grid, TextField } from '@mui/material';

const ProfileDataSection = ({ t, userData, errorMessage, onSetData }) => (
  <Grid className="personal-data__card">
    <h4 className="sub_head">{t('common.personalData')}</h4>
    <Grid className="personal-data__card-head">
      <Grid>
        <TextField
          error={errorMessage.firstName}
          label={t('personalData.firstName')}
          placeholder={t('personalData.firstName')}
          value={userData?.firstName || ''}
          fullWidth
          className="personal-data__text-field"
          onChange={onSetData}
          name="firstName"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        {errorMessage.firstName ? <div className="errorMessageInput">{errorMessage.firstName}</div> : null}
      </Grid>
      <Grid>
        <TextField
          error={errorMessage.lastName}
          label={t('personalData.Surname')}
          placeholder={t('personalData.Surname')}
          fullWidth
          value={userData?.lastName || ''}
          className="personal-data__text-field"
          onChange={onSetData}
          name="lastName"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        {errorMessage.lastName ? <div className="errorMessageInput">{errorMessage.lastName}</div> : null}
      </Grid>
      <Grid>
        <TextField
          error={errorMessage.company}
          label={t('personalData.company')}
          placeholder={t('personalData.company')}
          fullWidth
          className="personal-data__text-field"
          margin="normal"
          value={userData?.company || ''}
          onChange={onSetData}
          name="company"
          InputLabelProps={{ shrink: true }}
        />
        {errorMessage.company ? <div className="errorMessageInput">{errorMessage.company}</div> : null}
      </Grid>
    </Grid>
  </Grid>
);

export default ProfileDataSection;
